import * as React from 'react';
import { Redirect } from 'react-router-dom';
import {
  Wrapper,
  Content,
  BoxWrapper
} from './styled';

import { SidebarFeature } from '@app/src/commons/sidebar';
import { useAuthorization } from '@app/src/utils/validations';
import { HeaderFeature } from '@app/src/commons/header';
import { FilterFeature } from '@app/src/views/Users/filter';
import { ListFeature } from './list';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

interface Props {
  history: any;
}

export const Users: React.FC<Props> = ({ history }) => {
  const isNotAuthorization: boolean = !useAuthorization();
  const isAdmin: boolean = decodeAccessToken('isAdmin');

  if (isNotAuthorization) {
    return <Redirect to="/" />
  }

  if (isAdmin) {
    return (
      <Wrapper>
        <SidebarFeature history={history} />
        <Content>
          <BoxWrapper>
            <HeaderFeature subTitle="Usuarios" />
            <FilterFeature url={process.env.API_OPERATOR} />
            <ListFeature url={process.env.API_OPERATOR} />
          </BoxWrapper>
        </Content>
      </Wrapper>
    );
  }

  return <Redirect to="/generarcip" />;
};
